import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 bg-background-100/50">
      <div className="max-w-[600px] mx-auto px-8 text-center">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-600 hover:text-foreground-800 hover:border-foreground-400 text-[15px] tracking-[0.06em] transition-all duration-300 whitespace-nowrap"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-home-line text-xs"></i>
          </div>
          {t('sitemap.page.homeLink')}
        </Link>
      </div>
    </section>
  );
}
